import React from 'react'
import TableHeadRowCenter from '../../components/TableComponents/TableHeadRowCenter'
import TableBodyRowCenter from '../../components/TableComponents/TableBodyRowCenter'
import { Button } from 'react-bootstrap'
import { FaX } from 'react-icons/fa6'
import { FaCheck } from 'react-icons/fa'
import TableHeadRowStart from '../../components/TableComponents/TableHeadRowStart'
import TableBodyRowStart from '../../components/TableComponents/TableBodyRowStart'
import { formatarTelefone } from '../../utilities/formatarTelefoneInput'
import { whatsappNumber } from '../../utilities/birthdays'

// Telefone com link para a conversa no WhatsApp, na mesma regra dos Aniversariantes: com o 55, e o fixo só com
// 11 dígitos (é celular). Sem número para o WhatsApp, fica só o telefone
const PhoneLink = ({ phone, number }) => (number
  ? <a href={`https://wa.me/${number}`} target='_blank' rel='noopener noreferrer' title='Abrir a conversa no WhatsApp'>{formatarTelefone(phone)}</a>
  : formatarTelefone(phone ?? ''))

const TableData = ({ array, editFunction, deleteFunction }) => {
  return (
    <>
      <thead>
        <tr>
          <TableHeadRowCenter text='Ativo' />
          <TableHeadRowStart text='Nome' />
          <TableHeadRowStart text='Tel. Fixo' />
          <TableHeadRowStart text='Celular' />
          <TableHeadRowStart text='E-mail' />
          <TableHeadRowCenter text='Ações' />
        </tr>
      </thead>

      <tbody>
        {array?.map((cliente, index) => {
          return (
            <tr key={cliente.codigo} className='trBody'>
              <TableBodyRowCenter text={cliente.ativo === true ? <FaCheck /> : <FaX />} alt='Ativo' />
              <TableBodyRowStart text={cliente.nome} />
              <TableBodyRowStart text={<PhoneLink phone={cliente.telefone} number={whatsappNumber({ telefone: cliente.telefone })} />} />
              <TableBodyRowStart text={<PhoneLink phone={cliente.telefone2} number={whatsappNumber({ telefone2: cliente.telefone2 })} />} />
              <TableBodyRowStart text={<a href={`mailto:${cliente.email}`} title='E-mail'>{cliente.email}</a>} />

              <td className='tableRowCenter'>
                <div className='buttonContainer'>
                  <Button variant='outline-secondary' className='m-0 p-0 px-2' onClick={() => editFunction(cliente.id)}>Editar</Button>
                  <Button variant='outline-danger' className='m-0 p-0 px-2' onClick={() => deleteFunction(cliente.id)}>Remover</Button>



                </div>
              </td>
            </tr>
          )
        })}
      </tbody>
    </>
  )
}

export default TableData
